// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const ImageLandscapeOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 576 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M64 112c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h19.8l80.8-110.2c4.5-6.2 11.7-9.8 19.4-9.8s14.8 3.6 19.4 9.8l29.4 40.2 83.1-127.1a23.96 23.96 0 0140.2 0L485 400h27c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zm32 336H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H96zm64-288a32 32 0 110 64 32 32 0 110-64z"}}]},"name":"image-landscape","theme":"outlined"};

const ImageLandscapeOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={ImageLandscapeOutlinedSvg} />;
  ImageLandscapeOutlined.displayName = 'ImageLandscapeOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(ImageLandscapeOutlined);
